import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { agreedTermsService, seenTermsService } from '../../api/privateApis';
import {
  logout,
  setHasSeenTerms,
  setTokenofApp,
} from '../../redux/app/appActions';
import { RootState } from '../../redux/rootReducer';
import TermsConditions from '../shipment/payment/termsCondition';
import TermsConditionsOther from '../shipment/payment/termsConditionsOther';

function TermsAgreed() {
  const dispatch = useDispatch<any>();
  let navigate = useNavigate();
  const { userData: reduxUserData } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const [userData, setUserData] = useState(reduxUserData);
  const [termsChecked, setTermsChecked] = useState(userData?.is_terms_agreed);

  useEffect(() => {
    setUserData(reduxUserData);
  }, [reduxUserData]);

  function handleAction() {
    const updatedUserData = {
      ...userData,
      is_terms_agreed: termsChecked,
    };

    setUserData(updatedUserData);
    const seenTermsPayload = {
      account_number: updatedUserData?.account_number,
      has_seen_terms: true,
    };

    const agreeTermsPayload = {
      account_number: updatedUserData?.account_number,
      is_agree: termsChecked,
    };

    if (termsChecked) {
      agreedTermsService(agreeTermsPayload)
        .then((response) => {})
        .catch((e) => {});
    }

    seenTermsService(seenTermsPayload)
      .then((response) => {
        dispatch(setHasSeenTerms(true));
        window.scrollTo(0, 0);
        if (userData?.is_vendor) {
          navigate('/app/ship-now');
        } else {
          navigate('/app/dashboard');
        }
      })
      .catch((e) => {});
  }

  return (
    <div className='row p-5 pt-2'>
      <div className='col-sm-12 col-md-12 col-lg-12'>
        <div className='row text-center'>
          <div className='col-12'>
            <h1 className='display-5 fw-bold ubbe-blue pb-4 mt-3'>
              Terms and Conditions
            </h1>
          </div>
        </div>

        <div className='ubbe-card'>
          <div className='card-body p-5'>
            <TermsConditions />
          </div>
        </div>

        <div className='ubbe-card mt-4'>
          <div className='card-body p-5'>
            <TermsConditionsOther />
          </div>
        </div>

        <p className='mt-4 px-1'>
          By clicking, you agree to{' '}
          <Link target='_blank' to={`${process.env.REACT_APP_TERMS_URL}`}>
            Terms & Conditions
          </Link>{' '}
          and{' '}
          <Link to={`${process.env.REACT_APP_PRIVACY_URL}`} target='_blank'>
            Privacy Policy
          </Link>
          .
        </p>
        <div className='col-12 py-2'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              name='agreement_checkbox'
              id='agreement_checkbox'
              checked={termsChecked}
              onChange={(e) => {
                setTermsChecked(e.target.checked);
                setUserData((prevUserData: any) => ({
                  ...prevUserData,
                  is_terms_agreed: e.target.checked,
                }));
              }}
            />
            <label
              htmlFor='agreement_checkbox'
              className='globalInputLabel'
              style={{ marginTop: '0px' }}
            >
              Don't show this again
            </label>{' '}
          </div>
        </div>
        <div className='d-flex justify-content-between  mt-4 mb-5'>
          <p
            className='btn btn-ubbe-new-back d-flex gap-2 mb-0'
            onClick={() => {
              window.scrollTo(0, 0);
              localStorage.setItem('authToken', '');
              localStorage.removeItem('refreshToken');
              localStorage.removeItem('accessExpiry');
              dispatch(setTokenofApp(''));
              dispatch(logout());
              navigate('/login');
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </p>

          <button
            className='btn-ubbe-new-blue  justify-content-end '
            onClick={() => {
              handleAction();
            }}
          >
            Agree
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsAgreed;
